module.exports = __webpack_public_path__ + "img/1.b150f306.png";